import { openReportState } from 'app/area/favourite/constants';
import { SpinLoader } from 'app/components';
import * as React from 'react';
import { useEffect } from 'react';
import { useActionCreators } from 'app/area/favourite/hooks';

interface SavedDashboardRouteProps {
  params: { validFavouriteId: string; dashboardType: number; modifier1?: string; modifier2?: string };
}

export function SavedDashboardRoute({
  params
}: SavedDashboardRouteProps) {
  
  const favouriteId = params?.validFavouriteId && parseInt(params.validFavouriteId, 10);
  const editSavedFavourite = params.modifier1  === openReportState.edit || params.modifier2 === openReportState.edit;
  const dashboardType = params.dashboardType;

  const {
    createDashboardDraftDefinition
  } = useActionCreators();
  
  useEffect(() => {
    createDashboardDraftDefinition(favouriteId, dashboardType, editSavedFavourite);    
  }, []);

  return <SpinLoader />;
}
